import React from "react";
import orderBy from "lodash/orderBy";
import throttle from "lodash/throttle";
import clone from "lodash/clone";
import $ from 'jquery';
import PropTypes from 'prop-types';

import Misc from './../../misc/misc';
import ActionTypes from "./../../misc/actionTypes";
import {getMousePos, getTranslateX, requestAnimFrame, isTouchDevice} from "../../misc/utils";
import {makeHoveringLayer} from "../../misc/imageHovering";
import {getEventPosition, isIE} from "../../misc/helpers";
import PinchZoom from "../../lib/pinch-zoom";
import {loaderEnable, loaderDisable} from "../ui/loaderView";
import enhanceCanvas from "./canvasEnhancements";
import Config, {IS_LIXIL_UI} from "../../config";
import {checkForLayerParts} from "./canvasCheckForLayerParts";
import {hardCodelyRemovedClicking} from "../look/lookNavigation/lookFunctions2";
import {VISUALIZER_MANAGEMENT_ACTIONS} from "../../misc/constants";
import {removeLoadingElements} from "../../loadingLogic";
// import {UseFullSizeImages} from "../../config";

// import { getHoverZonesForPreset, getHoveringZone, hoverImages } from "./imageCanvasTouchZones";

export default class ImageCanvasCommon extends React.Component {
  static propTypes = {
    layers: PropTypes.arrayOf(PropTypes.object).isRequired,
    layoutType: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    canvasId: PropTypes.string.isRequired,
    useMouseHovering: PropTypes.bool,
    useTouchZoom: PropTypes.bool,
    enableLoader: PropTypes.func,
    disableLoader: PropTypes.func,
    setShowCanvasLoader: PropTypes.func,
    lookCanvasClick: PropTypes.func,
    transform: PropTypes.string,
    fabricatorData: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.canvas = null;
    this.state = {
      mouseMoveSet: false,
      dimensions: {
        width: props.width,
        height: props.height
      },
      hoverZones: {},
      layers: [],
      layersHoverings: [],
      // layersHoveringsCached: [],
      imagesRendered: [],
      backgroundLayers: [],
      backgroundImages: [],
      allowPropsLayers: true,
    };
    this.id = 0;
    this.ctx = null;
    this.backCtx = null;
    this.resizedCanvas = null;
    this.resizedContext = null;
    this.timeout = 0;
    this.canvas_scale = 1;
    this.shouldUpdateGreenZone = false;
    this.pinchZoom = null;
    this.x = 0;
    this.y = 0;
    this.delta = 0;
    this.statusSwipe = false;
    this.detectedSwipeLeft = false;
    this.detectedSwipeRight = false;
    this.currentTranslate = 0;
    this.navBreakPoint = 991;
    this.activeGreenZoneIndex = null;
    this.firstLayersAreLoaded = false;
    /*** background canvas ***/
    this.canvasBg = null;
    this.backCtxBg = null;
    /*** background canvas end ***/
  }

  componentDidMount() {
    const {width, height} = this.props;
    this.ctx = this.canvas.getContext('2d');
    const c = document.createElement('canvas');
    c.width = width;
    c.height = height;
    this.backCtx = c.getContext('2d');
    this.resizedCanvas = document.createElement("canvas");
    this.resizedContext = this.resizedCanvas.getContext("2d");

    /*** background canvas ***/
    this.canvasBg = document.createElement('canvas');
    this.canvasBg.width = width;
    this.canvasBg.height = height;
    this.backCtxBg = this.canvasBg.getContext('2d');
    this.backCtxBg.globalCompositeOperation = "lighten";
    /*** background canvas end ***/

    $(window).on('resize', this.handleOrientationChange);
    this.handleOrientationChange();
    $(window).on('setPinchZoom', this.createPinchZoom);
    if (window.setPinchZoom || IS_LIXIL_UI) {
      this.createPinchZoom();
    }
    $(window).on(ActionTypes.REMOVE_GREEN_ZONE_ON_CANVAS, (event, callback) => {
      this.draw(this.state.layers, callback);
    });

    if (Config.isVisualizerManagement()) {
      window.addEventListener("message", (event) => {
        if (event.data && (event.data.action === VISUALIZER_MANAGEMENT_ACTIONS.getState
          || event.data.action === VISUALIZER_MANAGEMENT_ACTIONS.checkState)) {
          this.draw(this.state.layers)
        }
      })
    }
    if (this.props.layers.length && this.state.allowPropsLayers) {
      this.drawPropsLayers();
    } else {
      removeLoadingElements("Canvas");
    }
  }

  componentWillUnmount() {
    $(window).off('resize', this.handleOrientationChange);
    $(window).off('setPinchZoom', this.createPinchZoom);
    $(window).off(ActionTypes.GET_CANVAS_SCALE);
    $(window).off(ActionTypes.RESET_CANVAS);
    $(window).off(ActionTypes.ENABLE_PINCH_ZOOM);
    $(window).off(ActionTypes.DISABLE_PINCH_ZOOM);
    $(window).off(ActionTypes.REMOVE_GREEN_ZONE_ON_CANVAS);
  }

  drawPropsLayers = () => {
    this.setState({
      layers: this.props.layers
    });
    this.shouldUpdateGreenZone = true;
    this.draw(this.props.layers, this.props.useMouseHovering
      ? this.updateGliaCanvasImage
      : removeLoadingElements.bind(this, "Canvas"));
  };

  createPinchZoom = () => {
    if ((Misc.isMobile() || isTouchDevice() || Config.isVisualizerManagement() || IS_LIXIL_UI) && this.props.useTouchZoom && !this.pinchZoom) {
      this.pinchZoom = new PinchZoom(this.canvas, {canUseUpdate: this.props.useTouchZoom});
      $(window).on(ActionTypes.RESET_CANVAS, () => {
        // $('.canvas-text').html('xxx');
        this.pinchZoom.reset();
      });
      $(window).on(ActionTypes.ENABLE_PINCH_ZOOM, () => {
        this.pinchZoom.enable();
      });
      $(window).on(ActionTypes.DISABLE_PINCH_ZOOM, () => {
        this.pinchZoom.disable();
      });
      if (this.props.updateLookCanvas) {
        this.props.updateLookCanvas();
      }
    }
    // const dashboardFramed = Config.isVisualizerManagement();
  };

  componentWillReceiveProps(nextProps) {
    const onlyLayers = nextProps.layers.filter((layer) => {
      return !layer.image.includes("/static")
    });
    const onlyStateLayers = this.state.layers.filter((layer) => {
      return !layer.image.includes("/static")
    });

    let needToUpdateCanvas = onlyLayers.length !== onlyStateLayers.length,
      i = 0;

    if (!needToUpdateCanvas && onlyLayers.length && onlyStateLayers.length) {
      for (i; i < onlyLayers.length; i++) {
        if (onlyLayers[i].zIndex !== onlyStateLayers[i].zIndex || onlyLayers[i].image !== onlyStateLayers[i].image) {
          needToUpdateCanvas = true;
          // console.log('break on ' + i + ' element');
          break;
        }
      }
    }

    if (nextProps.layers.length && this.state.allowPropsLayers) {
      this.setState({
        layers: nextProps.layers
      });
      // if (this.state.mouseMoveSet) {
      //     this.setLayersHoverings(nextProps.layers);
      // }
    }

    if (needToUpdateCanvas && this.state.allowPropsLayers) {
      this.shouldUpdateGreenZone = true;
      this.draw(nextProps.layers, this.props.useMouseHovering ? this.updateGliaCanvasImage : null);
    }
  }

  handleOrientationChange = () => {
    const canvas = $(this.canvas);
    const canvasWidth = canvas.width();
    const canvasHeight = canvas.height();
    const fromDesktopToMobile = this.state.dimensions.width > this.navBreakPoint && canvasWidth < this.navBreakPoint;
    const fromMobileToDesktop = this.state.dimensions.width < this.navBreakPoint && canvasWidth > this.navBreakPoint;
    this.setState({
      dimensions: {
        width: canvasWidth,
        height: canvasHeight,
        layersHoverings: (fromDesktopToMobile || fromMobileToDesktop) ? [] : this.state.layersHoverings,  // recreate layersHoverings
      }
    });
  };

  imageCanvasScroll = (canvasClass, removeAllClasses) => {
    if (!window.canvasIsDragging && this.pinchZoom) {
      this.pinchZoom.reset();
      // $('.canvas-text').html($('.canvas-text').html() + canvasClass);
      this.pinchZoom.imageCanvasScroll(
        canvasClass.toLowerCase().replace(" ", "-"),
        removeAllClasses,
        this.props.layoutType,
        this.props.layoutScene
      );
    }
  };

  layerIsExcludedFromHover = (layer) => {
    const {layout} = this.props;
    if (Array.isArray(layout.disabledClickablePartIds) && layout.disabledClickablePartIds.includes(layer.partId)) {
      return true
    }
    if (hardCodelyRemovedClicking(layer.partId, layout, this.props.fabricatorData)) {
      return true
    }
    return layout.excludedPartIdsFromHover
      ? layer.partId && layout.excludedPartIdsFromHover.some(partId => partId === layer.partId || layer.partId.indexOf(partId) > -1)
      : layout.excludedIndexesFromHover
        ? layout.excludedIndexesFromHover(this.props.layoutType).includes(layer.zIndex)
        : false
  }

  setLayersHoverings = (layers, images, errorImages) => {

    let layersHoverings = this.state.layersHoverings, i;
    // console.log('this.state.layersHoverings-->', this.state.layersHoverings);
    // console.log('layers', layers);

    const {layout} = this.props;

    layers.forEach((layer, index) => {

      // console.log('setLayersHovering:', layer);

      const excludedLayer = this.layerIsExcludedFromHover(layer, layout);

      if (!layer.isGreenHovering && !excludedLayer) {
        // search for current layer zIndex
        const existingGreenLayerHoveringIndex = layersHoverings.findIndex((layerHovering) => {
          return layerHovering ? layerHovering.layer.zIndex === layer.zIndex : 0
        });

        const getHoveringLayer = () => {
          return makeHoveringLayer(layer, images[index], this.props.layoutType, {
            width: this.props.width,
            height: this.props.height
          }, this.props.fabricatorData)
        }

        // if it exist & name is different - change it(simple layer replace)
        if (existingGreenLayerHoveringIndex > -1) {
          if (layer.image !== this.state.layersHoverings[existingGreenLayerHoveringIndex].layer.image
            && images[index] && !errorImages.includes(images[index].src)) {
            const hoveringLayer = getHoveringLayer();
            if (hoveringLayer) {
              layersHoverings.splice(existingGreenLayerHoveringIndex, 1, hoveringLayer)
            }
          }
        } else {
          if (images[index] && !errorImages.includes(images[index].src)) {
            const hoveringLayer = getHoveringLayer();
            if (hoveringLayer) {
              layersHoverings.push(hoveringLayer) // simple push
            }
          } else {
            console.info("makeHoveringLayer failed! no image for layer", index);
          }
        }
      }
    });

    for (i = 0; i < layersHoverings.length; ++i) {  // go over new green layers, and remove redundant
      const notNeededMoreLayerIndex = layers.findIndex((layer) => {
        return layer.zIndex === layersHoverings[i].layer.zIndex
      });
      if (notNeededMoreLayerIndex === -1) {
        layersHoverings.splice(i, 1);
        --i; // Correct the index value
      }
    }

    this.setState({
      layersHoverings: orderBy(layersHoverings, 'layer.zIndex', layout.isNewLayout ? 'asc' : 'desc')
      // order by zIndex (top go last in new layouts)
    }, () => {
      this.shouldUpdateGreenZone = false;
    });
  };

  draw = (layers, callback) => {

    let cnt = 0;
    const images = [];

    // if (!window.count) {
    //   window.count = 1;
    // }
    // console.log('draw!', window.count);
    // window.count++;

    this.id = setTimeout(() => {
      if (!this.id) {
        return;
      }
      clearTimeout(this.id);
      if (this.props.setShowCanvasLoader) {
        if (!window.requestInProcess) {
          this.props.setShowCanvasLoader(true)
        }
      } else if (layers.length) {
        this.props.enableLoader
          ? this.props.enableLoader(true)
          : loaderEnable("loader.canvasLoadingText");
      }
    }, 500);

    this.backCtx.fillStyle = 'white';
    this.backCtx.fillRect(0, 0, this.props.width, this.props.height);
    // this.backCtx.clearRect(0, 0, this.props.width, this.props.height);

    // console.log('layers', layers);

    const alreadyRenderedImages = this.state.imagesRendered;
    const errorImages = [];

    // if (this.state.errorImages.length) {
    //   layers = layers.filter(layer => !this.state.errorImages.includes(layer.image))
    // }

    layers.forEach((layer) => {
      const alreadyRenderedImage = alreadyRenderedImages.find((imageRendered) => {
        return layer.image === imageRendered.src
      });
      let image;
      if (layer.isGreenHovering) {
        image = layer.hoveringImage;
      } else if (alreadyRenderedImage && this.state.allowPropsLayers) {
        image = alreadyRenderedImage.image;
        if (!isIE()) { // IE11 doesn't like when someone is making empty src
          image.src = ""; // https://bugs.chromium.org/p/chromium/issues/detail?id=7731#c12
        }
      } else {
        image = new Image();
        image.crossOrigin = 'Anonymous';
        alreadyRenderedImages.push({
          image,
          src: layer.image
        });
      }
      image.layerDimensions = layer.layerDimensions || null;
      image.coords = layer.coords || null;
      images.push(image);
      image.onload = () => {
        cnt++;
        if (cnt === layers.length) {
          this.finishDraw(images, layers, alreadyRenderedImages, errorImages, callback)
        }
      };
      image.onerror = () => {
        //display error
        console.info('Coudn\'t load image:', image.src);
        cnt++;
        errorImages.push(image.src);
        if (cnt === layers.length) {
          this.finishDraw(images, layers, alreadyRenderedImages, errorImages, callback);
        }
      };
      try {
        image.src = layer.image;
      } catch (e) {
        console.log(e, 'Can\'t apply image src', layer.image);
      }

    });
  };

  getBackgroundLayers = (layers = this.state.layers) => {
    const {layoutType, layout} = this.props;
    return layers.filter((layer) => {
      return layout.zIndexes[layoutType] && layout.zIndexes[layoutType].Background &&
        Object.values(layout.zIndexes[layoutType].Background).some(zIndex => zIndex === layer.zIndex);
    })
  };

  finishDraw = (images, layers, alreadyRenderedImages, errorImages, callback) => {
    clearTimeout(this.id);
    this.id = 0;

    const {width, height} = this.props;

    // const fullImagesFactor = UseFullSizeImages ? 100 : 54;

    const backgroundLayers = this.getBackgroundLayers(layers);

    if (backgroundLayers.length) { // draw backgrounds first
      this.backCtxBg.clearRect(0, 0, width, height); // clear previous

      const greenImage = images.find((imageObject) => imageObject.src.includes("data:image"));
      if (greenImage) {
        const layer = backgroundLayers.find(layer => layer.image === greenImage.src);
        if (layer && layer.zIndex !== 500) {
          const greenImageIndex = images.findIndex((imageObject) => imageObject.src.includes("data:image"));
          images.splice(greenImageIndex - 1, 1); // remove regular layer, draw only green one
        }
      }

      images.forEach((imageObject) => {
        if (errorImages.includes(imageObject.src)) {
          return
        }
        const layer = backgroundLayers.find(layer => layer.image === imageObject.src);
        if (layer) {
          if (layer.layerDimensions) {
            const dim = layer.layerDimensions;
            // console.log('yep', dim.width, dim.height, dim.polygonArray[0][0], dim.polygonArray[0][1], dim.width, dim.height);
            this.backCtxBg.drawImage(imageObject, 0, 0, dim.width, dim.height, dim.polygonArray[0][0], dim.polygonArray[0][1], dim.width, dim.height);
          } else {
            // imageObject.width = width;
            // imageObject.height = height;
            this.backCtxBg.drawImage(imageObject, 0, 0, width, height);
          }
        }
        imageObject = null;
      });
      enhanceCanvas(this.canvasBg);
      this.backCtx.drawImage(this.canvasBg, 0, 0, width, height, 0, 0, width, height);
    }

    images.forEach((loadedImage) => {
      if (errorImages.includes(loadedImage.src)) {
        return
      }
      const layer = layers.find(layers => layers.image === loadedImage.src);
      if (layer && (!backgroundLayers.length || (layer.zIndex > backgroundLayers[backgroundLayers.length - 1].zIndex))) {
        if (loadedImage.layerDimensions) {
          const dim = loadedImage.layerDimensions;
          // console.log('yep', dim.width, dim.height, dim.polygonArray[0][0], dim.polygonArray[0][1], dim.width, dim.height);
          this.backCtx.drawImage(loadedImage, 0, 0, dim.width, dim.height, dim.polygonArray[0][0], dim.polygonArray[0][1], dim.width, dim.height);
        } else if (loadedImage.coords) {
          // loadedImage.width = loadedImage.width*fullImagesFactor/100;
          // loadedImage.height = loadedImage.height*fullImagesFactor/100;
          // const max_x = loadedImage.coords.max_x*fullImagesFactor/100;
          const min_x = this.props.width*loadedImage.coords.min_x;
          const min_y = this.props.height*loadedImage.coords.min_y;
          // const max_y = loadedImage.coords.max_y*fullImagesFactor/100;
          // const width = max_x - min_x;
          // const height = max_y - min_y;
          // console.log('width', width);
          // console.log('height', height);
          // console.log('min_x', min_x);
          // console.log('min_y', min_y);
          // console.log('max_x', max_x);
          // console.log('max_y', max_y);
          try {
            this.backCtx.drawImage(loadedImage, 0, 0, loadedImage.width, loadedImage.height, min_x, min_y, loadedImage.width, loadedImage.height);
          } catch (e) {
            console.log(e, 'Can\'t draw image with coords on the canvas', loadedImage.src);
          }
        } else {
          try {
            this.backCtx.drawImage(loadedImage, 0, 0, width, height, 0, 0, width, height);
          } catch (e) {
            console.log(e, 'Can\'t draw image on the canvas', loadedImage.src);
          }
        }
      }
      loadedImage = null;
    });

    // this.ctx.drawImage(this.backCtx.canvas, 0, 0);
    requestAnimFrame(this.ctx.drawImage(this.backCtx.canvas, 0, 0));

    if (this.props.useMouseHovering) {
      const isMobile = Misc.isMobile() || isTouchDevice();
      if (!isMobile && !isIE() && !this.state.mouseMoveSet && this.canvas) {
        this.setOnMouseMove();
      }
      this.setState({
        alreadyRenderedImages
      });
      if (this.shouldUpdateGreenZone || !this.state.layersHoverings.length) {
        this.setLayersHoverings(layers, images, errorImages)
      }
    }

    if (!window.requestInProcess) {
      this.props.disableLoader ? this.props.disableLoader(false) : loaderDisable();
    }

    // window.t1 = performance.now();
    // console.log("Call to doSomething took " + (window.t1 - window.t0) + " milliseconds.");

    if (callback) {
      callback()
    }
  };

  getGliaImage = () => {
    return <img ref={(el) => this.canvasImg = el} alt="" id={this.props.canvasId + "Img"}
                className="canvas-co-image" />
  };

  updateGliaCanvasImage = () => {
    // if (this.pinchZoom && this.pinchZoom.containerScrolled && layers.some(layer => layer.image.includes('data:image/png;base64'))) {
    //   return
    // }
    if (this.resizedContext && this.canvas) {
      this.resizedCanvas.height = this.canvas.height / 2;
      this.resizedCanvas.width = this.canvas.width / 2;
      const backgroundCanvas = document.getElementById("canvasBackgrounds");
      if (backgroundCanvas) {
        this.resizedContext.drawImage(backgroundCanvas, 0, 0, this.resizedCanvas.width, this.resizedCanvas.height);
      }
      this.resizedContext.drawImage(this.canvas, 0, 0, this.resizedCanvas.width, this.resizedCanvas.height);
      this.canvasImg.src = this.resizedCanvas.toDataURL("image/jpeg", 0.7);
    }
    if (!this.firstLayersAreLoaded) {
      this.firstLayersAreLoaded = true;
      removeLoadingElements("Canvas");
    }
  };

  setOnMouseMove = () => {
    this.setState({
      mouseMoveSet: true
    });
    const delayBetweenUpdates = 50;
    this.canvas.addEventListener('mousemove', throttle(this.setHoveredLayer, delayBetweenUpdates), false);
  };

  setHoveredLayer = (evt) => {

    const {layoutType, layout} = this.props;
    const canvas = this.canvas;
    let mousePos = getMousePos(evt, canvas);
    let hovered = false;

    // console.log('mousePos', mousePos);

    if (Misc.isMobile() || isTouchDevice() || isIE()) {
      if (this.props.useTouchZoom) {
        $(window).trigger(ActionTypes.GET_CANVAS_SCALE);
      }
    }

    if (mousePos && (window.innerWidth < 480)) { // rotated version
      let temp = mousePos.x;
      // noinspection JSSuspiciousNameCombination
      mousePos.x = mousePos.y;
      mousePos.y = this.canvas.offsetHeight - temp;
      // console.log('mousePos2', mousePos);
    }

    if (this.state.layersHoverings.length) {
      let i = 0;
      for (i; i < this.state.layersHoverings.length; i++) {
        const layerHovering = this.state.layersHoverings[i];
        if ( mousePos
          && layerHovering
          && layerHovering.layerDimensions
          && !this.layerIsExcludedFromHover(layerHovering.layer, layout)
          // && pnpoly(layerHovering.layerDimensions.polygonArray, mousePos)
          && layerHovering.context2D.getImageData(
            (((mousePos.x / this.canvas_scale) / this.state.dimensions.width * this.props.width)) - layerHovering.layerDimensions.polygonArray[0][0],
            (((mousePos.y / this.canvas_scale) / this.state.dimensions.height * this.props.height)) - layerHovering.layerDimensions.polygonArray[0][1],
            1,
            1,
            {willReadFrequently: true}).data[3] > 120) {
          hovered = true;
          document.hoveredLayer = layerHovering.layer;
          document.hoveredMousePos = mousePos;
          if (!isIE() && (this.activeGreenZoneIndex !== layerHovering.layer.zIndex)) {
            // console.log('layerHovering active = ', layerHovering);
            const windowHover = layerHovering.layer.zIndex === layout.zIndexes[layoutType].Window_Default;
            let windowLayerHovering = '';
            if (windowHover) {
              windowLayerHovering = this.state.layersHoverings.find(layersHovering => {
                return layersHovering.layer.zIndex === layout.zIndexes[layoutType].Window_Covering
              });
            }
            this.activeGreenZoneIndex = layerHovering.layer.zIndex;
            this.renderGreenLayer(windowHover && windowLayerHovering ? windowLayerHovering : layerHovering);
          }

          break;  // break for...of loop
        }
      }
    }

    if (!hovered) {
      document.hoveredLayer = null;
      this.draw(this.state.layers);   // reload all layers without hovered
    }

  };

  renderGreenLayerByZindex = (zIndex) => {
    if (!isIE()) {
      const neededLayerHovering = this.state.layersHoverings.find((layerHovering) => {
        return layerHovering.layer.zIndex === zIndex
      });
      neededLayerHovering ? this.renderGreenLayer(neededLayerHovering) : this.draw(this.state.layers)
    }
  };

  renderGreenLayer = (layerHovering, allLayers = false) => {
    let layers = clone(this.state.layers);

    clearTimeout(this.timeout); // timeout for updating layers

    const hoveredLayerIndex = layers.findIndex((layer) => {
      if (this.props.layout && this.props.layout.isNewLayout && layerHovering) {
        return (layer.zIndex === layerHovering.layer.zIndex) && (layerHovering.layer.partId === layer.partId)
      }
      return layer.zIndex === layerHovering.layer.zIndex
    });

    if (hoveredLayerIndex > -1) {
      const layersToRender = checkForLayerParts(this, layers, hoveredLayerIndex, layerHovering, allLayers);
      // console.log('layersToRender', layersToRender);
      this.draw(layersToRender);
      this.timeout = setTimeout(() => {   // remove green layer
        this.activeGreenZoneIndex = null;
        if (this.canvas) {
          this.draw(this.state.layers);
        }
      }, 2000);
    }
  };

  moveStart = (event) => {
    const eventPosition = getEventPosition(event);
    const thisX = parseFloat(eventPosition.x).toFixed(2);
    const thisY = parseFloat(eventPosition.y).toFixed(2);
    setTimeout(() => {
      if (window.mobileMenuOpened && !window.imageCanvasScroll && !window.imageCanvasScroll2) {
        this.x = thisX;
        this.y = thisY;
        this.statusSwipe = true;
        this.detectedSwipeLeft = false;
        this.detectedSwipeRight = false;
        this.currentTranslate = getTranslateX(this.canvas);
        $('.canvas-text').html(this.currentTranslate);
      }
    }, 100);
  };

  move = (event) => {

    if (this.statusSwipe && window.mobileMenuOpened) {

      window.canvasIsDragging = true;

      const eventPosition = getEventPosition(event);

      let
        x = parseFloat(eventPosition.x).toFixed(2),
        y = parseFloat(eventPosition.y).toFixed(2),
        tX = parseFloat((x - this.x).toFixed(2)),
        tY = parseFloat((y - this.y).toFixed(2));

      if (!this.detectedSwipeRight || !this.detectedSwipeLeft) {
        if (Math.abs(parseFloat(tX)) >= this.delta) {
          if (parseFloat(tX) > this.delta) {
            this.detectedSwipeRight = true;
          } else if (parseFloat(tX) < -this.delta) {
            this.detectedSwipeLeft = true;
          }
        }
      }

      if ((this.detectedSwipeLeft || this.detectedSwipeRight) && Math.abs(tX) > Math.abs(tY)) {
        // console.log('Math.abs(tX)', Math.abs(tX));

        const nextPosition = Math.round((this.currentTranslate + tX)*100)/100;
        const percentage = this.state.dimensions.width < 680 ? 60 : 50;
        // const percentage = 50;
        const visibleCanvasWidth = (percentage / 100) * this.state.dimensions.width;  // percentage of number

        // console.log('nextPosition', nextPosition);
        // $('.canvas-text').html(nextPosition);
        // console.log('visibleCanvasWidth', visibleCanvasWidth);

        if (Math.abs(nextPosition) < visibleCanvasWidth && nextPosition < 0) {
          const transform2d = 'translateX(' + nextPosition + 'px)';
          this.canvas.style.webkitTransform = transform2d;
          this.canvas.style.mozTransform = transform2d;
          this.canvas.style.msTransform = transform2d;
          this.canvas.style.oTransform = transform2d;
          this.canvas.style.transform = transform2d;
        }
      }
    }

  };

  moveEnd = () => {

    // let
    //   x = getEventPosition(e).x,
    //   tX = parseFloat((x - this.x).toFixed(2));

    this.x = 0;
    this.y = 0;
    this.statusSwipe = false;
    if (this.pinchZoom) {
      $(window).trigger(ActionTypes.CANVAS_SCALE_CHANGED, [this.pinchZoom.getScale()]);
    }

    if (this.detectedSwipeLeft || this.detectedSwipeRight) {
      this.currentTranslate = getTranslateX(this.canvas);
      this.detectedSwipeLeft = false;
      this.detectedSwipeRight = false;
      window.canvasIsDragging = false;
      this.pinchZoom.enable();
      // $(this.canvas).css({
      //   transform: `none`
      // });
    }
  };

  render() {
    return (
      <div className="canvas" style={{position: "static"}}>
        {/*<div className="canvas-text"/>*/}
        {this.getGliaImage()}
        <canvas ref={(el) => this.canvas = el}
                className={"canvas-el" + (this.props.useMouseHovering ? " canvas-el--pointer" : "")}
                id={this.props.canvasId}
                width={this.props.width}
                height={this.props.height}
                onTouchStart={this.moveStart}
                onTouchMove={this.move}
                onTouchEnd={this.moveEnd}
                style={{position: "relative"}} />
      </div>
    );
  }
}
